import { getMeasurementSymbol } from 'src/utils/utilities'
import { dateIsAfter, getDaysBetweenDates } from 'src/utils/dateUtils'

export const segmentationReportTypeEnum = {
  BY_SELLS: { id: 1, name: 'Venta por ordenes de venta' },
  BY_CLIENTS: { id: 2, name: 'Ventas a clientes' },
  BY_ITEMS: { id: 3, name: 'Por productos vendidos' },
  BY_CPC: { id: 4, name: 'Por cuentas por cobrar' },
  BY_PAYMENTS: { id: 5, name: 'Pagos de cuentas por cobrar' },
  BY_INVOICED_ITEMS: { id: 6, name: 'Por ítems facturados' },
}

export const segmentationReportTypes: IReportSegmentationType[] = [
  {
    value: segmentationReportTypeEnum.BY_SELLS.id,
    label: segmentationReportTypeEnum.BY_SELLS.name,
    headers: [
      { show: true, label: 'CÓDIGO', type: 'text', value: ['code'] },
      { show: true, label: 'NOMBRE', type: 'text', value: ['clientName'] },
      { show: true, label: 'NIT', type: 'text', value: ['nit'] },
      { show: true, label: 'FECHA EMISIÓN', type: 'date', value: ['firstDate'] },
      { show: true, label: 'UTILIDAD BRUTA', type: 'currency', value: ['thirdValue'] },
      { show: true, label: 'DESCUENTO', type: 'currency', value: ['secondValue'] },
      { show: true, label: 'TOTAL', type: 'currency', value: ['firstValue'] },
    ],
  },
  {
    value: segmentationReportTypeEnum.BY_CLIENTS.id,
    label: segmentationReportTypeEnum.BY_CLIENTS.name,
    headers: [
      { show: true, label: 'CÓDIGO', type: 'text', value: ['code'] },
      { show: true, label: 'NOMBRE', type: 'text', value: ['name'] },
      { show: true, label: 'NIT', type: 'text', value: ['nit'] },
      { show: true, label: 'TOTAL', type: 'currency', value: ['firstValue'] },
    ],
  },
  {
    value: segmentationReportTypeEnum.BY_ITEMS.id,
    label: segmentationReportTypeEnum.BY_ITEMS.name,
    headers: [
      { show: true, label: 'CÓDIGO', type: 'text', value: ['code'] },
      { show: true, label: 'NOMBRE', type: 'text', value: ['name'] },
      {
        show: true,
        label: 'MEDIDA',
        type: 'text',
        value: ['measurementValue'],
        custom: item =>
          `${item.measurementValue} ${getMeasurementSymbol(item.measurementUnitId)}`,
      },
      { show: true, label: 'CANTIDAD', type: 'number', value: ['secondValue'] },
      { show: true, label: 'PRECIO PROMEDIO', type: 'currency', value: ['thirdValue'] },
      { show: true, label: 'ÚLTIMA VENTA', type: 'date', value: ['firstDate'] },
      {
        show: true,
        label: 'ÚLTIMO PRECIO DE VENTA',
        type: 'currency',
        value: ['fourthValue'],
      },
      { show: true, label: 'TOTAL', type: 'currency', value: ['firstValue'] },
    ],
  },
  {
    value: segmentationReportTypeEnum.BY_CPC.id,
    label: segmentationReportTypeEnum.BY_CPC.name,
    headers: [
      { show: true, label: 'CÓDIGO', type: 'text', value: ['code'] },
      { show: true, label: 'NOMBRE', type: 'text', value: ['clientName'] },
      { show: true, label: 'TOTAL', type: 'currency', value: ['fourthValue'] },
      { show: true, label: 'FECHA EMISIÓN', type: 'date', value: ['firstDate'] },
      { show: true, label: 'DÍAS DE CRÉDITO', type: 'number', value: ['secondValue'] },
      { show: true, label: 'FECHA DE VENCIMIENTO', type: 'date', value: ['secondDate'] },
      {
        show: true,
        label: 'DÍAS DE CRÉDITO DE VENCIMIENTO',
        type: 'number',
        value: ['thirdValue'],
      },
      { show: true, label: 'PENDIENTE', type: 'currency', value: ['firstValue'] },
    ],
  },
  {
    value: segmentationReportTypeEnum.BY_PAYMENTS.id,
    label: segmentationReportTypeEnum.BY_PAYMENTS.name,
    headers: [
      { show: true, label: 'CÓDIGO', type: 'text', value: ['code'] },
      { show: true, label: 'ESTADO', type: 'text', value: ['stateName'] },
      { show: true, label: 'NOMBRE', type: 'text', value: ['clientName'] },
      { show: true, label: 'NIT', type: 'text', value: ['nit'] },
      { show: true, label: 'FECHA DE CREACIÓN', type: 'date', value: ['secondDate'] },
      { show: true, label: 'FECHA DE PAGO', type: 'date', value: ['firstDate'] },
      { show: true, label: 'FECHA DE CONFIRMACIÓN', type: 'date', value: ['thirdDate'] },
      { show: true, label: 'TOTAL', type: 'currency', value: ['secondValue'] },
      { show: true, label: 'ORDEN', type: 'text', value: ['reference'] },
      { show: true, label: 'FECHA CREACIÓN VENTA', type: 'date', value: ['fourthDate'] },
      { show: true, label: 'FECHA DE PAGO VENTA', type: 'date', value: ['fifthDate'] },
      {
        show: true,
        label: 'DÍAS DE MOROSIDAD',
        type: 'text',
        value: [],
        custom: item => getDaysOfDelay(item),
      },
      {
        show: true,
        label: 'MORA',
        type: 'text',
        value: [],
        custom: item => getDaysOfSettled(item),
      },
      { show: true, label: 'MONTO', type: 'currency', value: ['firstValue'] },
    ],
  },
  {
    value: segmentationReportTypeEnum.BY_INVOICED_ITEMS.id,
    label: segmentationReportTypeEnum.BY_INVOICED_ITEMS.name,
    headers: [
      { show: true, label: 'CÓDIGO', type: 'text', value: ['code'] },
      { show: true, label: 'FECHA EMISIÓN', type: 'date', value: ['firstDate'] },
      { show: true, label: 'AUTORIZACIÓN', type: 'text', value: ['reference'] },
      { show: true, label: 'ANULADA', type: 'text', value: ['stateName'] },
      { show: true, label: 'ÍTEM', type: 'text', value: ['name'] },
      { show: true, label: 'Lote / Fecha v.', type: 'text', value: ['batch'] },
      { show: true, label: 'CANTIDAD', type: 'number', value: ['secondValue'] },
      { show: true, label: 'PRECIO', type: 'currency', value: ['thirdValue'] },
      { show: true, label: 'TOTAL', type: 'currency', value: ['firstValue'] },
    ],
  },
]

const getDaysOfDelay = (item: ISegmentation): number => {
  if (!item.fifthDate) return 0
  if (dateIsAfter(item.fifthDate, Date.now())) return 0
  if (!item.thirdValue) return 0

  return getDaysBetweenDates(item.fifthDate, Date.now())
}

const getDaysOfSettled = (item: ISegmentation): number => {
  if (!item.fifthDate) return 0
  if (!item.sixthDate) return 0
  if (item.thirdValue && item.thirdValue > 0) return 0

  const daysBetween: number = getDaysBetweenDates(item.fifthDate, item.sixthDate)
  return Math.max(daysBetween, 0)
}
